module.exports = __webpack_public_path__ + "img/table_chailv.8b49f968.png";